const TaleidoData = [
  {
    id: 1,

    name: "AMORY LOVINS",

    details: "Adjunct Professor & Scholar, Stanford University",

    imgSrc:
      "https://res.cloudinary.com/doe7b5us3/image/upload/v1673978954/Kaleido-Prev/Taleido-1_mumfcc.jpg",

    content:
      "Professor at Stanford University. Former chairman/chief scientist of Rocky Mountain Institute. He has won many awards like Time Magazines for world’s 100 most influential people and Blue Planet Prize. Wrote energy policy for 4 decades and served on US National Petroleum Council. Works for environment efficient energy since he started RMI and made many projects like Hypercar, Solar heater, etc. Worked with many companies listed under Fortune 500 and UN for energy consumption. Wrote over 31 books, he's a physicist and an advocate.",

    ytlink: "https://youtu.be/HxMQa-1-TLk",
  },
  {
    id: 2,

    name: "VIRGINIA SHARMA",

    details: "India Marketing Head, Google Cloud",

    imgSrc:
      "https://res.cloudinary.com/doe7b5us3/image/upload/v1673978953/Kaleido-Prev/Taleido-2_rg97ma.jpg",

    content:
      "Current Head of Marketing at Google. Non-executive independent board director at Pennar Industries. Before Google, she was Vice President of Marketing at IBM. Also worked for LinkedIn as Sales Director of Marketing and JioSaavn as Vice President of Brand Solutions.First chairperson for the Marketing Society India Chapter. Awarded with top 100 Indian business leaders by Exchange4media, Economics Times Women Ahead and Impact top 50 women in Marketing Media & Advertising 3 years in a row, 2018, 2019 and 2020. She has also received recognition as LinkedIn Top Voices in Gender Equity",

    ytlink: "https://youtu.be/s88Yz2QRSHQ",
  },
];

export default TaleidoData;
